var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoSfComputeOutline = function SvgLogoSfComputeOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "90px",
    height: "90px",
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "logo-tiny-circle-outline")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "small-variant",
    transform: "translate(-596, -1399)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-tiny-circle-outline",
    transform: "translate(596, 1399)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "currentColor",
    strokeWidth: 5,
    cx: 45,
    cy: 45,
    r: 42.5
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-6-Copy-14",
    stroke: "currentColor",
    strokeWidth: 3,
    points: "59.5454545 41.8 83.6909091 63.6181818 81 67.5 59.5890909 48.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-6-Copy-13",
    stroke: "currentColor",
    strokeWidth: 3,
    points: "43.8363636 31.7636364 50.2363636 30.8909091 54.0181818 33.6545455 53 41.0727273"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6727273,30.8909091 L26.6727273,23.0363636 L29.7272727,20.8545455 L29.8727273,18.3818182 C30.5515152,17.9939394 30.8909091,17.8 30.8909091,17.8 C30.8909091,17.8 32.8787879,20.2242424 36.8545455,25.0727273 L26.6727273,30.8909091 Z",
    id: "Combined-Shape-Copy-14",
    stroke: "currentColor",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0181818,12.5636364 L59.6909091,19.2545455 L59.9818182,54.3090909 L60.7090909,55.7636364 L61,85.5454545 L50.2363636,85.5454545 L50.2363636,71.4727273 L48.7818182,70.0181818 L38.1636364,70.8909091 L35.8363636,72.6363636 L35.8363636,85.5454545 L25.3636364,85.5454545 L25.3636364,58.6727273 L26.3818182,57.3636364 L26.6727273,39.3272727 L51.2545455,25.9454545 L51.2545455,17.5090909 L52.8545455,15.9090909 L52.8545455,13.4363636 L54.0181818,12.5636364 Z M48.0545455,36.2727273 L38.1636364,38.3090909 L35.1090909,40.0545455 L35.1090909,57.8 L35.9818182,58.8181818 L49.3636364,56.9272727 L51.1090909,55.1818182 L50.8181818,39.0363636 L48.0545455,36.2727273 Z",
    id: "Combined-Shape-Copy-13",
    stroke: "currentColor",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-4-Copy-7",
    stroke: "currentColor",
    strokeWidth: 3,
    points: "1 43.8909091 54.0181818 15.6181818 54.0181818 21.2909091 1 50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,35.6181818 C2,35.6181818 2,37.4121212 2,41 L26.8181818,27.8363636 L29.7272727,20.8545455 C11.2424242,30.6969697 2,35.6181818 2,35.6181818 Z",
    id: "Path-5-Copy-7",
    stroke: "currentColor",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-7-Copy-7",
    stroke: "currentColor",
    strokeWidth: 3,
    points: "54.0181818 12.5636364 59.6909091 25.9454545 86.8470576 51.4405173 87 45"
  }))))));
};
export default SvgLogoSfComputeOutline;